<template>
  <page :manualInit="statistics.init" :manualErr="statistics.initErr" @reload="doInit">
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
export default {
  data() {
    return {

    }
  },
  computed: {
    statistics() {
      return this.$store.state.parameters.statistics
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('statisticsInit')
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style>

</style>
